import { defineRouter } from '#q-app'
import { createRouter, createWebHistory, createMemoryHistory } from 'vue-router'
import routes from './routes'
import { hasMissingQueryParams, mergeQueryParams } from './persistent-query'

export default defineRouter(() => {
  const router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    history: import.meta.env.QUASAR_SERVER ? createMemoryHistory() : createWebHistory()
  })

  // Global router guard to keep query params persistent when changing paths
  router.beforeEach((to, from) => {
    const fromQueryKeys = Object.keys(from.query)
    if (
      to.params.environmentId === from.params.environmentId &&
      to.path !== from.path &&
      hasMissingQueryParams(from.query, to.query)
    ) {
      // Keep all query params from the previous route
      return { ...to, query: mergeQueryParams(from.query, to.query) }
    } else if (
      fromQueryKeys.length &&
      !Object.keys(to.query).length &&
      fromQueryKeys.some((key) => key?.startsWith('f-'))
    ) {
      // Only keep feature flags
      const query = {
        ...Object.fromEntries(Object.entries(from.query).filter(([key]) => key?.startsWith('f-'))),
        ...to.query
      }
      return { ...to, query }
    }
  })

  return router
})
